import { render, staticRenderFns } from "./user_notes_detailed.vue?vue&type=template&id=7cb7b062&scoped=true"
import script from "./user_notes_detailed.vue?vue&type=script&lang=js"
export * from "./user_notes_detailed.vue?vue&type=script&lang=js"
import style0 from "./user_notes_detailed.vue?vue&type=style&index=0&id=7cb7b062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb7b062",
  null
  
)

export default component.exports